import { createSlice } from '@reduxjs/toolkit'
import { fetchNutritionalGoals, saveSelectedGoals, fetchCompatibleProtocols, saveProtocolTimeline } from '../actions/protocolActions'

const initialState = {
	selectedGoals: [],
	availableGoals: [],
	compatibleProtocols: [],
	selectedProtocol: null,
	currentSubStep: 1, // 1-4 for the 4 sub-screens
	isLoading: false,
	error: null,
}

const protocolSelectionSlice = createSlice({
	name: 'protocolSelection',
	initialState,
	reducers: {
		setLoading: (state, action) => {
			state.isLoading = action.payload
		},
		setError: (state, action) => {
			state.error = action.payload
		},
		setAvailableGoals: (state, action) => {
			state.availableGoals = action.payload
		},
		setSelectedGoals: (state, action) => {
			state.selectedGoals = action.payload
		},
		setCompatibleProtocols: (state, action) => {
			state.compatibleProtocols = action.payload
		},
		setSelectedProtocol: (state, action) => {
			state.selectedProtocol = action.payload
		},
		setCurrentSubStep: (state, action) => {
			state.currentSubStep = action.payload
		},
		resetProtocolSelection: (state) => {
			state.selectedGoals = []
			state.availableGoals = []
			state.compatibleProtocols = []
			state.selectedProtocol = null
			state.currentSubStep = 1
			state.isLoading = false
			state.error = null
		},
	},
	extraReducers: (builder) => {
		builder
			// Fetch nutritional goals
			.addCase(fetchNutritionalGoals.pending, (state) => {
				state.isLoading = true
				state.error = null
			})
			.addCase(fetchNutritionalGoals.fulfilled, (state, action) => {
				state.isLoading = false
				state.availableGoals = action.payload
				state.error = null
			})
			.addCase(fetchNutritionalGoals.rejected, (state, action) => {
				state.isLoading = false
				state.error = action.payload
			})
			// Save selected goals
			.addCase(saveSelectedGoals.pending, (state) => {
				state.isLoading = true
				state.error = null
			})
			.addCase(saveSelectedGoals.fulfilled, (state) => {
				state.isLoading = false
				state.error = null
			})
			.addCase(saveSelectedGoals.rejected, (state, action) => {
				state.isLoading = false
				state.error = action.payload
			})
			// Fetch compatible protocols
			.addCase(fetchCompatibleProtocols.pending, (state) => {
				state.isLoading = true
				state.error = null
			})
			.addCase(fetchCompatibleProtocols.fulfilled, (state, action) => {
				state.isLoading = false
				state.compatibleProtocols = action.payload
				state.error = null
			})
			.addCase(fetchCompatibleProtocols.rejected, (state, action) => {
				state.isLoading = false
				state.error = action.payload
			})
			// Save protocol timeline
			.addCase(saveProtocolTimeline.pending, (state) => {
				state.isLoading = true
				state.error = null
			})
			.addCase(saveProtocolTimeline.fulfilled, (state) => {
				state.isLoading = false
				state.error = null
			})
			.addCase(saveProtocolTimeline.rejected, (state, action) => {
				state.isLoading = false
				state.error = action.payload
			})
	},
})

export const {
	setLoading,
	setError,
	setAvailableGoals,
	setSelectedGoals,
	setCompatibleProtocols,
	setSelectedProtocol,
	setCurrentSubStep,
	resetProtocolSelection,
} = protocolSelectionSlice.actions

export default protocolSelectionSlice.reducer
